"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPreviewProductsWidget = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const widget_1 = require("../components/widget");
exports.StyledPreviewProductsWidget = (0, styled_components_1.default)(widget_1.Widget) `
  overflow-y: hidden;
  padding: 0;

  .no-preview-products {
    width: 300px;

    .text-block-title {
      color: ${({ theme }) => theme.palette.accent.main};
    }
  }

  .preview-products-actions {
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
  }

  .preview-products-skeleton {
    padding: ${({ theme }) => theme.spacing(1)};
  }
`;
